import { useEffect, useState } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";

type Props = {
  onExtend: () => void;
  onExpire: () => void;
};

export default function SessionWarningModal({ onExtend, onExpire }: Props) {
  const [secondsRemaining, setSecondsRemaining] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onExpire();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Dialog open={true} onClose={onExpire} className="fixed z-50 inset-0 flex items-center justify-center p-4 bg-black/50">
      <DialogPanel className="bg-white rounded-2xl p-6 max-w-md w-full shadow-xl">
        <div className="flex items-center space-x-4">
          <ExclamationIcon className="h-8 w-8 text-yellow-500" />
          <DialogTitle className="text-lg font-semibold text-gray-800">
            Session Expiring Soon
          </DialogTitle>
        </div>

        <div className="mt-4 text-sm text-gray-600">
          Your session will expire in <strong>{secondsRemaining} seconds</strong>.
          Would you like to stay logged in?
        </div>

        <div className="mt-6 flex flex-wrap justify-between gap-3">
          <button
            onClick={onExpire}
            className="flex-1 min-w-[120px] px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
          >
            Log out
          </button>
          <button
            onClick={onExtend}
            className="flex-1 min-w-[120px] px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
          >
            Keep me logged in
          </button>
        </div>

      </DialogPanel>
    </Dialog>
  );
}
